// react
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { DYNAMIC_ROUTES } from 'router';

// components
import { Actions } from '@karehero/llama/pwa/pages/Actions/Actions';
import { Typography } from '@mui/material';

// hooks
import { useActionPlan } from 'hooks/useActionPlan';
import { useCareCircle } from 'hooks';

/**
 * ActionPlan shows the action plan page.
 */
export const ActionPlan = () => {
  // hooks
  const navigate = useNavigate();
  const { careCircleId } = useCareCircle();
  const { allActionPlanItems, actionPlanCategories } = useActionPlan();

  // memos
  const categories = useMemo(
    () =>
      (actionPlanCategories || []).map((category) => ({
        id: category.id,
        title: category.title,
        progress:
          category.totalItems > 0
            ? Math.round((category.completedItems / category.totalItems) * 100)
            : 0,
        onClick: () =>
          navigate(DYNAMIC_ROUTES.ACTION_PLAN_CATEGORY(category.id)),
      })),
    [actionPlanCategories, navigate],
  );

  return (
    <Actions
      title='My Actions'
      description='Track your progress across each category of your care plan.'
      categories={!careCircleId ? [] : categories}
      emptySlot={
        <Typography
          variant='body1'
          sx={{
            color: 'text.secondary',
            textAlign: 'center',
          }}
        >
          Please ensure you have selected a care circle.
        </Typography>
      }
    />
  );
};

export default ActionPlan;
